var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedThumbDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 0.5H8.5V7L5 10.5L4.375 9.875C4.31667 9.81667 4.26875 9.7375 4.23125 9.6375C4.19375 9.5375 4.175 9.44167 4.175 9.35V9.175L4.725 7H1.5C1.23333 7 1 6.9 0.8 6.7C0.6 6.5 0.5 6.26667 0.5 6V5C0.5 4.94167 0.508333 4.87917 0.525 4.8125C0.541667 4.74583 0.558333 4.68333 0.575 4.625L2.075 1.1C2.15 0.933333 2.275 0.791667 2.45 0.675C2.625 0.558333 2.80833 0.5 3 0.5ZM7.5 1.5H3L1.5 5V6H6L5.325 8.75L7.5 6.575V1.5ZM8.5 7V6H10V1.5H8.5V0.5H11V7H8.5Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedThumbDown);
export default __webpack_public_path__ + "static/media/Red_thumb_down.aaea90145ff4aa863234d8718adae52f.svg";
export { ForwardRef as ReactComponent };